<template>
  <div
    class="landing-layout w-full h-full"
    :class="[
      route.path === '/blogs' || route.path.includes('/blogs')
        ? 'bg-gray-100'
        : 'bg-white',
    ]"
  >
    <LayoutHeader
      :show-mobile="showMobile"
      @showMobileMenu="showMobile = true"
    />
    <LayoutMobileMenu
      :show-mobile="showMobile"
      @hideMobileMenu="showMobile = false"
    />
    <div class="md:min-h-[calc(100vh)]">
      <slot />
    </div>
    <LayoutFooter />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import LayoutHeader from "./components/Header.vue";
import LayoutMobileMenu from "./components/MobileMenu.vue";
import LayoutFooter from "./components/Footer.vue";

const showMobile = ref(false);

const route = useRoute();

watch(showMobile, (val: boolean) => {
  if (val) {
    document.body.style.overflow = "hidden";
    return;
  }
  document.body.style.overflowY = "auto";
});
</script>

<style scoped>
.landing-layout {
  font-family: "Soleil", sans-serif !important;
}
</style>
